/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Chain_To_Next_EventInputs */

const en_shortcut_keys_name_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chain To Next Event`)
};

const fr_shortcut_keys_name_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chainer a l'evenement suivant`)
};

const de_shortcut_keys_name_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verbindung zum nächsten Ereignis`)
};

const it_shortcut_keys_name_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catena al prossimo evento`)
};

const ru_shortcut_keys_name_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Цепочка к следующему событию`)
};

const es_shortcut_keys_name_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadena al siguiente evento`)
};

const zh_cn2_shortcut_keys_name_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链至下一个事件`)
};

const ja_shortcut_keys_name_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`次のイベントへのチェーン`)
};

const hi_shortcut_keys_name_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगले इवेंट से जुड़ें`)
};

const pt_pt2_shortcut_keys_name_chain_to_next_event = /** @type {(inputs: Shortcut_Keys_Name_Chain_To_Next_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encadear para o próximo evento`)
};

/**
* | output |
* | --- |
* | "Chain To Next Event" |
*
* @param {Shortcut_Keys_Name_Chain_To_Next_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_chain_to_next_event = /** @type {((inputs?: Shortcut_Keys_Name_Chain_To_Next_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Chain_To_Next_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_chain_to_next_event(inputs)
	if (locale === "de") return de_shortcut_keys_name_chain_to_next_event(inputs)
	if (locale === "it") return it_shortcut_keys_name_chain_to_next_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_chain_to_next_event(inputs)
	if (locale === "es") return es_shortcut_keys_name_chain_to_next_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_chain_to_next_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_chain_to_next_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_chain_to_next_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_chain_to_next_event(inputs)
	return en_shortcut_keys_name_chain_to_next_event(inputs)
});